@for (group of splitItemsTemplateData(); track group.category.value) {
  <div class="card card-sm border-secondary">
    <div class="card-body">
      <div class="row align-items-center mb-3">
        <div class="col">
          <div class="fw-medium mb-0">
            {{ group.category.name }}
            @if (group.category.account_code) {
              ({{ group.category.account_code }})
            }
          </div>
        </div>
        <div class="col-auto ms-auto">
          Sub total: {{ group.subtotal | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
        </div>
      </div>

      @for (item of group.items; track $index) {
        <div class="card card-sm bg-pays-subtle border-0 mb-2 mt-0">
          <div class="card-body p-2">
            <div class="mb-1">{{ item.name }}</div>
            <div class="row align-items-center gx-2">
              <div class="col-auto">
                <span class="text-sm text-muted">Tax Type: </span>
                <div
                  class="badge bg-info text-info"
                  [ngClass]="{ 'bg-danger text-danger': hasActiveConnection() && !getTaxRate(item.tax)?.name }">
                  @if (hasActiveConnection()) {
                    {{ getTaxRate(item.tax)?.name ? getTaxRate(item.tax)?.name : 'No tax selected' }}
                    @if (getTaxRate(item.tax)?.rate) {
                      ({{ getTaxRate(item.tax)?.rate }}%)
                    }
                  } @else if (item.vat !== null) {
                    {{ returnVatTypeLabel(item.vat) }}
                  } @else {
                    No type selected
                  }
                </div>
              </div>
              <div class="col-auto ms-auto text-end fw-semibold">
                {{ item.amount | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
